require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware-fixed/~/core-js/library/fn/object/set-prototype-of.js
// module id = a+sg
// module chunks = 23